import { lazyWithRetry } from '@repo/error';

import { ParkingChosenGuard } from '@features/reservation';

import { ROUTE_PATHS } from '@router/paths';
import { RouteName } from '@router/routeNames';
import type { AppRouteObject } from '@router/types';

const ParkingSearchPage = lazyWithRetry(() => import('@features/parkingSearch/pages/ParkingSearchPage'));
const ParkingSearchResultsPage = lazyWithRetry(() => import('@features/parkingSearch/pages/ParkingSearchResultsPage'));
const ParkingDetailsPage = lazyWithRetry(() => import('@features/parkingSearch/pages/ParkingDetailsPage'));
const ParkingRedirectPage = lazyWithRetry(() => import('@features/parkingSearch/pages/ParkingRedirectPage'));

export const parkingSearchRoutes: AppRouteObject[] = [
  {
    path: ROUTE_PATHS[RouteName.PARKING_LANDING],
    element: <ParkingRedirectPage />,
  },
  {
    path: ROUTE_PATHS[RouteName.PARKING_LANDING_WITH_SPOT],
    element: <ParkingRedirectPage />,
  },
  {
    path: ROUTE_PATHS[RouteName.MAP],
    children: [
      {
        index: true,
        name: RouteName.MAP,
        element: <ParkingSearchPage />,
      },
      {
        path: ROUTE_PATHS[RouteName.PARKING_SEARCH_RESULTS],
        name: RouteName.PARKING_SEARCH_RESULTS,
        element: <ParkingSearchResultsPage />,
      },
      {
        element: <ParkingChosenGuard />,
        children: [
          {
            path: ROUTE_PATHS[RouteName.PARKING_DETAILS],
            name: RouteName.PARKING_DETAILS,
            element: <ParkingDetailsPage />,
          },
        ],
      },
    ],
  },
];
